import React, { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import Map from "../components/Map";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const [locations, setLocations] = useState([
    { id: "1", name: "Display 1", lat: 43.8563, lng: 18.4131, status: "Online" },
    { id: "2", name: "Display 2", lat: 44.1194, lng: 17.9077, status: "Offline" },
    { id: "3", name: "Display 3", lat: 43.3438, lng: 17.8086, status: "Online" },
  ]);
  const [user, setUser] = useState(null);
  const auth = getAuth();
  const navigate = useNavigate();

  const displayStats = {
    online: locations.filter((loc) => loc.status === "Online").length,
    offline: locations.filter((loc) => loc.status === "Offline").length,
  };

  const handleLogout = () => {
    auth
      .signOut()
      .then(() => {
        console.log("Logged out successfully.");
        navigate("/"); // Redirect to the login page
      })
      .catch((error) => console.error("Error logging out:", error));
  };

  // Fetch user info on mount
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser.email || "Guest");
      } else {
        setUser(null);
        navigate("/"); // Redirect to login if not authenticated
      }
    });

    return () => unsubscribe();
  }, [auth, navigate]);

  return (
    <div style={{ padding: "20px" }}>
      {/* User Info and Logout */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h3 style={{ marginRight: "20px" }}>
          Welcome, <span style={{ color: "#4CAF50" }}>{user || "Loading..."}</span>
        </h3>
        <button
          onClick={handleLogout}
          style={{
            backgroundColor: "#f44336",
            color: "#fff",
            border: "none",
            padding: "10px 20px",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Logout
        </button>
      </div>

      {/* Dashboard Content */}
      <h1>Dashboard</h1>
      <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        {/* Display Status Overview */}
        <div
          style={{
            padding: "20px",
            backgroundColor: "#e8f5e9",
            borderRadius: "8px",
            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h2>Status Overview</h2>
          <p>
            <strong>Online:</strong> {displayStats.online}
          </p>
          <p>
            <strong>Offline:</strong> {displayStats.offline}
          </p>
        </div>

        {/* Screen Locations Map */}
        <div
          style={{
            padding: "20px",
            backgroundColor: "#ffffff",
            borderRadius: "8px",
            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h2>Screen Locations</h2>
          <Map locations={locations} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
